import { Component, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { CommonModule } from '@angular/common';
import { SettingService } from 'src/app/services/setting/setting.service';
import { LanguageService } from 'src/app/services/language/language.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-setting',
  imports: [SpinnerComponent, CommonModule, FormsModule],
  templateUrl: './setting.component.html',
  styleUrl: './setting.component.css'
})
export class SettingComponent {

  load = false
  error = false
  data: any

  currentLang = 'ge'
  @ViewChild('editModal') editModal!: TemplateRef<any>;

  editData: any = {};

  value: string = ''

  editBtnLoad = false

  constructor(
    private SettingService: SettingService, 
    private langService: LanguageService,
    private modalService: NgbModal,
    private ToastrService: ToastrService,
  ){
    
    this.langService.currentLanguage$.subscribe((lang) => {
        this.currentLang = lang;
          this.get()
      });
    this.get()
  }

  get(){
    this.load = true
    this.SettingService.get().subscribe(
      (res: any) => {
        this.error = false
        this.load = false
        this.data = res
      },
      (error: any) => {
        this.load = false
        this.error = true
      }
    )
  }

  openEditModal(data: any){
    this.editData = { ...data };
    this.value = data.value;
    this.modalService.open(this.editModal);
  }

  getTitle(key: string){
    if(key == 'sitetitle'){return 'ვეგბვერდის დასახელება'}
    if(key == 'keywords'){return 'საძიებო სიტყვები'}
    if(key == 'description'){return 'საძიებო აღწერა'}
    if(key == 'mail'){return 'ელ.ფოსტა'}
    if(key == 'phone'){return 'მობილური'}
    if(key == 'addresslink'){return 'მისამართი ბმული'}
    if(key == 'address'){return 'მისამართი'}
    if(key == 'site'){return 'ვებგვერდი'}
    return key;
  }

  update(modal: any) {
    
    const data = {
      ... this.editData,
      value: this.value
     }
      
    this.editBtnLoad = true;
    this.SettingService.update(data).subscribe(
      (res: any) => {
        this.editBtnLoad = false;
        this.ToastrService.success('პარამეტრები წარმატებით შეიანახა');
        modal.close();
        this.get()
      },
      () => {
        this.editBtnLoad = false;
        this.ToastrService.error('შეცდომა პარამეტრების შენახვისას');
      }
    );
    
  }

}
